import React from 'react';
import './GameOver.css';

const GameOver = ({ 
  winner, 
  lastRemoved, 
  multipleAnswers, 
  optimalSolution, 
  showOptimalSolution, 
  setShowOptimalSolution,
  onPlayAgain,
  onBackToMenu
}) => {
  return (
    <div className="game-over">
      <h2>ゲーム終了！</h2>
      <p className="winner">プレイヤー {winner} の勝利！</p>
      
      <div className="game-over-details">
        <p>
          プレイヤー {winner === 1 ? 2 : 1} が行 {lastRemoved.row + 1}、列 {lastRemoved.col + 1} の
          「{lastRemoved.value}」を消去したことで解の一意性が失われました。
        </p>
        
        {multipleAnswers.length >= 2 && (
          <div className="multiple-answers">
            <h3>詳細な解説:</h3>
            <p>このマスを消すと少なくとも2つの妥当な解が存在するようになります。例えば:</p>
            
            <div className="solutions-container">
              {multipleAnswers.slice(0, 2).map((solution, index) => (
                <div key={index} className="solution">
                  <h4>解答例 {index + 1}:</h4>
                  <div className="mini-board">
                    {solution.map((row, rowIndex) => (
                      <div key={`row-${rowIndex}`} className="mini-row">
                        {row.map((cell, colIndex) => (
                          <div
                            key={`cell-${rowIndex}-${colIndex}`}
                            className={`
                              mini-cell
                              ${(rowIndex + 1) % 3 === 0 && rowIndex < 8 ? 'border-bottom' : ''}
                              ${(colIndex + 1) % 3 === 0 && colIndex < 8 ? 'border-right' : ''}
                              ${rowIndex === lastRemoved.row && colIndex === lastRemoved.col ? 'highlight-cell' : ''}
                            `}
                          >
                            {cell !== 0 ? cell : ''}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            
            <p className="explanation">
              消したマスを見ると、複数の数字が入る可能性があり、それぞれが妥当な数独解になります。
              赤くハイライトされているマスが、複数の値を取り得るマスです。
            </p>
          </div>
        )}
        
        {optimalSolution && (
          <div className="optimal-solution">
            <button
              className="toggle-button"
              onClick={() => setShowOptimalSolution(!showOptimalSolution)}
            >
              {showOptimalSolution ? '最適解を隠す' : '最適解を表示する'}
            </button>
            
            {showOptimalSolution && (
              <div className="optimal-solution-content">
                <h3>模範解答:</h3>
                <p>
                  失敗する直前の状態から、さらに {optimalSolution.removedCells.length} マス
                  安全に消すことができました。
                </p>
                
                <div className="optimal-board-container">
                  <h4>最適解の最終状態:</h4>
                  <div className="mini-board">
                    {optimalSolution.finalBoard.map((row, rowIndex) => (
                      <div key={`opt-row-${rowIndex}`} className="mini-row">
                        {row.map((cell, colIndex) => (
                          <div
                            key={`opt-cell-${rowIndex}-${colIndex}`}
                            className={`
                              mini-cell
                              ${(rowIndex + 1) % 3 === 0 && rowIndex < 8 ? 'border-bottom' : ''}
                              ${(colIndex + 1) % 3 === 0 && colIndex < 8 ? 'border-right' : ''}
                            `}
                          >
                            {cell !== 0 ? cell : ''}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
                
                {optimalSolution.removedCells.length > 0 && (
                  <div className="removal-sequence">
                    <h4>安全に消せるマスの順序:</h4>
                    <div className="removal-cells">
                      {optimalSolution.removedCells.map((cell, index) => (
                        <div key={index} className="removal-cell">
                          <span className="step-number">{index + 1}</span>
                          <span className="cell-position">
                            行{cell.row + 1}、列{cell.col + 1}の「{cell.originalValue}」
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                <p className="conclusion">
                  これらのマスはすべて安全に消去でき、それぞれの削除後も解の一意性が保たれます。
                  さらに{optimalSolution.remainingCellsCount}マスは、どれを消しても一意性が
                  失われるため消去できません。
                </p>
              </div>
            )}
          </div>
        )}
        
        <div className="game-over-actions">
          <button className="action-button play-again" onClick={onPlayAgain}>
            もう一度プレイ
          </button>
          <button className="action-button back-to-menu" onClick={onBackToMenu}>
            メニューに戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOver;
